import { Box, TextField, MenuItem, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

export function TransferItemRow({
  index,
  item,
  transferType,
  getProductCatalogOptions,
  getProductOptions,
  updateItem,
  removeItem,
  canRemove,
}) {
  const disableCatalogAndProduct =
    transferType === "daily_operation" || transferType === "transfer" || transferType === "product_sales";

  const catalogOptions = getProductCatalogOptions();
  const productOptions = getProductOptions(item.product_catalog_id);

  // Normalize to string so Select + MenuItem match correctly
  const catalogValue =
    item.product_catalog_id !== undefined && item.product_catalog_id !== null
      ? String(item.product_catalog_id)
      : "";

  const productValue =
    item.product_id !== undefined && item.product_id !== null
      ? String(item.product_id)
      : "";

    // if (transferType === "finished_project") {
    //   item.amount = item.max_amount
    // }

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        mt: 1,
        alignItems: "center",
        gap: 1,
      }}
    >
      <TextField
        className="transfer-item-product-catalog"
        select
        label="貨種（產品目錄）"
        value={catalogValue}
        onChange={(e) => {
          const v = e.target.value; // string
          updateItem(index, "product_catalog_id", v);
          updateItem(index, "product_id", ""); // reset product
        }}
        disabled={disableCatalogAndProduct}
      >
        {catalogOptions.map((cat) => (
          <MenuItem key={cat.id} value={String(cat.id)}>
            {cat.name}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        className="transfer-item-product"
        select
        label="貨物"
        value={productValue}
        onChange={(e) => {
          const v = e.target.value; // string
          updateItem(index, "product_id", v);
        }}
        disabled={disableCatalogAndProduct}
      >
        {productOptions.map((p) => (
          <MenuItem key={p.product_id} value={String(p.product_id)}>
            {p.product_name}
          </MenuItem>
        ))}
      </TextField>

      {/* 數量 */}
      <TextField
        className="transfer-item-product-amount"
        type="number"
        label="數量"
        value={item.amount === "" ? "" : Number(item.amount ?? 0)}
        onChange={(e) => updateItem(index, "amount", e.target.value)}
      />

      {(transferType === "daily_operation" || transferType === "transfer" || transferType === "product_sales" ) && (
        <Box sx={{ minWidth: 70 }}>/ {item.max_amount}</Box>
      )}

      {canRemove && (
        <IconButton onClick={() => removeItem(index)}>
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
}
